export const LogoIcon = () => <span style={{color:'#97ded3',fontSize:27,fontWeight:700}}>S</span>;
